import SEOMeta from '../../components/feature/SEOMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesList from './components/ServicesList';
import WorkFormats from './components/WorkFormats';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

function ServicesHero() {
  const { t } = useTranslation();
  return (
    <section
      className="relative pt-40 pb-20"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/98c463ef9a62c22c0999733799cbdafa.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/55 to-gray-900/40"></div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <nav className="flex items-center justify-center gap-2 text-sm text-white/60 mb-8">
          <a href="/" className="hover:text-white cursor-pointer transition-colors duration-200">{t('servicesPage.heroNav')}</a>
          <i className="ri-arrow-right-s-line text-white/40"></i>
          <span className="text-white/90">{t('servicesPage.heroNavCurrent')}</span>
        </nav>
        <h1 className="text-5xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
          {t('servicesPage.heroTitle').split('\n').map((line, i, arr) => (
            <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
          ))}
        </h1>
        <p className="text-lg text-white/75 max-w-2xl mx-auto leading-relaxed">
          {t('servicesPage.heroDesc')}
        </p>
        <div className="mt-4 w-24 h-1 bg-blue-500 mx-auto rounded-full"></div>
      </div>
    </section>
  );
}

function ServicesFinalCTA() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <div className="bg-blue-50 border border-blue-100 rounded-3xl px-10 py-14">
          <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-2xl mx-auto mb-6">
            <i className="ri-customer-service-2-line text-white text-2xl"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('servicesPage.ctaTitle')}
          </h2>
          <p className="text-gray-500 text-base mb-8 max-w-md mx-auto">
            {t('servicesPage.ctaDesc')}
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="whitespace-nowrap inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium px-8 py-4 rounded-full transition-all duration-200 text-sm cursor-pointer"
          >
            {t('servicesPage.ctaBtn')} <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}

export default function ServicesPage() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'zh' ? 'zh' : 'en';

  return (
    <div className="min-h-screen bg-white">
      <SEOMeta
        title={t('seo.services.title')}
        description={t('seo.services.description')}
        canonical={`${siteUrl}/services`}
        lang={lang}
      />
      <Header />
      <main>
        <ServicesHero />
        <ServicesList />
        <WorkFormats />
        <ServicesFinalCTA />
      </main>
      <Footer />
    </div>
  );
}
